export default __webpack_public_path__ + "static/media/sub-category-musicAndArts-theatreSpace.92df7e0b.jpg";